import { notification } from 'antd';
import actions from './actions';
import { DataService } from '~/config/dataService/dataService';

const { getDataBegin, getDataSuccess, getDataErr } = actions;

const getConfig = () => {
  return async dispatch => {
    dispatch(getDataBegin());
    return DataService.post('client/config')
      .then(response => {
        const { status, data, result } = response;
        if (status !== 200) {
          dispatch(getDataErr(`error code ${status}`));
          notification.error({
            message: 'Desculpa! Ocorreu um erro',
            description: 'Houve um erro ao carregar as configurações dessa tela, por favor tente novamente mais tarde.',
          });
        } else {
          document.title = data.name;
          dispatch(getDataSuccess(data));
        }
      })
      .catch(err => {
        notification.error({
          message: 'Desculpa! Ocorreu um erro',
          description: 'Houve um erro ao carregar as configurações dessa tela, por favor tente novamente mais tarde.',
        });
        dispatch(getDataErr(err));
      });
  };
};

export { getConfig };
